import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { useState } from "react";

/**
 * Client-side HandleGate (ZS-1320): social graph actions require the caller to hold a handle,
 * so a handle-less caller is sent to pick one instead of getting the backend's HandleRequired
 * failure as a generic toast. The backend enforces the gate regardless. `needsHandle` asserts
 * only AFTER user-info loads — a still-loading handle must not flash the gate.
 */
export const useHandleGate = () => {
  const user = useLoggedInUser();
  // The caller's handle comes from React Query user-info — the Redux user loses it on
  // SPA sign-in (SignInResult carries no handle).
  const { data: userInfo } = useUserInfoQuery(!!user);
  const [isGateOpen, setIsGateOpen] = useState(false);

  const needsHandle = !!userInfo && !userInfo.handle;
  const openGate = () => setIsGateOpen(true);
  const closeGate = () => setIsGateOpen(false);
  const guarded = (action: () => void) => () =>
    needsHandle ? openGate() : action();

  return { needsHandle, isGateOpen, openGate, closeGate, guarded };
};
